import React, { Component } from 'react'
import PropTypes from 'prop-types'
import StyleSheet from 'styles/StyleSheet'
import Typography from '@material-ui/core/Typography'
import { authorizedLink } from 'utils/AuthorizationUtils'

export class Partners extends Component {

  static propTypes = {
    partners: PropTypes.array
  }

  render = () =>
    <div className={this.props.className}>
      {this.props.partners && this.props.partners.length > 0 &&
        <Typography variant='h5'>Partners</Typography>
      }

      {this.props.partners && this.props.partners.map(partner =>
        {
          const { id, logoUrls, name, websiteUrl } = partner
          const img = <img className={styles.logo} key={id} src={authorizedLink(logoUrls.smallLandscape)} alt={name} />

          if(!!websiteUrl) {
            return (<a key={id} href={ websiteUrl } target='_blank' rel='noopener noreferrer'>{ img }</a>)
          }

          return img
        }
      )}
    </div>
}

const styles = StyleSheet({
  logo: {
    maxWidth: 162,
    maxHeight: 48,
    marginRight: 80,
    marginTop: 30,
    verticalAlign: 'middle'
  }
})

export default Partners